import React, { useState } from "react";
import { service_insurance } from "../../../data/servicesData";

const HealthTabPage = () => {
  const [data] = useState(service_insurance?.health_sickness || {});
  return (
    <div className="text-left space-y-2">
      <p className="font-bold">{data.title}</p>
      <div className="space-y-2">
        {data.overview.map((item, index) => (
          <div key={index}>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthTabPage;
